<template>
    <div class="event-show-overview-page__item media-block">
        <div class="event-show-overview-page__item__image media-block__image">
            <img :src="imgSrc" loading="lazy" decoding="async" width="500" height="500" alt="" aria-hidden="true" />
            <div class="attraction-order" v-if="showAttractionOrder">{{result.number}}</div>
        </div>
        <div class="event-show-overview-page__item__list media-block__content">
            <div class="media-block__content__text stack">
                <h2 class="header--xsmall" v-show="result.preHeadline !== undefined && result.preHeadline != null">{{result.preHeadline}}</h2>
                <h3 class="header--small">{{result.headline}}</h3>
                <p>{{result.bodyText}}</p>
                <div class="icon-with-text" v-for="(icon, index) in result.iconText" :key="index" v-html="format(icon)">
                    
                </div>
                <p class="event-show-overview-page__item__list__link-wrapper link-wrapper breakout-button">
                    <a :href="result.url" target="_self" class="link-button link-button--primary">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 12" width="16" height="12" aria-hidden="true" focusable="false">
                            <path fill="#000" d="M11.5355339 5L8.2426407 1.7071068c-.3905243-.3905243-.3905243-1.0236893 0-1.4142136.3905243-.39052427 1.0236893-.39052427 1.4142135 0l5.6568543 5.6568543-5.6568543 5.6568542c-.3905242.3905243-1.0236892.3905243-1.4142135 0-.3905243-.3905243-.3905243-1.0236893 0-1.4142135L11.4350288 7H1c-.55228475 0-1-.4477153-1-1s.44771525-1 1-1h10.5355339z"></path>
                        </svg>
                        <span>{{result.linkText}}</span>
                    </a>
                </p>

            </div>

        </div>
    </div>
</template>

<script>
import Vue from 'vue';

export default {
    props: ['result'],
    methods: {
        format(icon) {
            return icon.icon + icon.text;
        }
    }, 
    computed: {
        imgSrc() {
            return this.result.imageUrl;
        },
        icons() {
            return [];
        },
        showAttractionOrder() {          
           return this.result.number;
        }
    }   
}
</script>